// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"204":"d8a76fce","278":"f98947cc","638":"9c147c2d","901":"b06b6f55"}[chunkId] + ".chunk.css";
};